import {faFloppyDisk} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import LoadingButton from '@mui/lab/LoadingButton';
import {useSaveButton} from '@refinedev/core';
import type {SaveButtonProps} from '@refinedev/mui';
import {FC} from 'react';

/**
 * `<SaveButton>` uses Material UI {@link https://mui.com/material-ui/api/loading-button/#main-content `<LoadingButton>`} component.
 * It uses it for presantation purposes only. Some of the hooks that refine has adds features to this button.
 *
 * @see {@link https://refine.dev/docs/api-reference/mui/components/buttons/save-button} for more details.
 */
export const SaveButton: FC<SaveButtonProps> = ({hideText = false, children, ...rest}) => {
  const {label} = useSaveButton();

  const {sx, ...restProps} = rest;

  return (
    <LoadingButton
      startIcon={!hideText && <FontAwesomeIcon icon={faFloppyDisk} />}
      sx={{minWidth: 0, ...sx}}
      variant="soft"
      color="success"
      {...restProps}
    >
      {hideText ? <FontAwesomeIcon icon={faFloppyDisk} size="lg" /> : (children ?? label)}
    </LoadingButton>
  );
};
